/**
 * PureLink portal links
 *
 * Keeps each link's existing destination and only makes
 * account.purelinkav.com links open in a new tab.
 */

document.addEventListener('DOMContentLoaded', () => {
  const updatePortalLinks = () => {
    document
      .querySelectorAll('a[href^="https://account.purelinkav.com/"]')
      .forEach((link) => {
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      });
  };

  updatePortalLinks();

  // Also handle menu links added dynamically by the theme.
  const observer = new MutationObserver(updatePortalLinks);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});